import axiosInstance from "./axios-service/axiosInstance";
import resumeServiceInstance from "./axios-service/resumeServiceInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
  Prefer: "odata.include-annotations=*",
};

const requisitionService = {
  getListData: () => {
    return axiosInstance.get(
      `https://agora-recruitment.crm8.dynamics.com/api/data/v9.2/itl_requisitions`,
      {
        headers: headers,
      }
    );
  },

  fetchRequisitions: () => {
    return axiosInstance.get(
      "/itl_requisitions?$select=itl_prescreeningrequired,itl_requisitionid,_itl_assignto_value,itl_budgetfrom,itl_budgetto,itl_department,itl_newjobdescription,itl_name,itl_note,itl_numberofopenings,itl_relevantexperiencemonths,itl_relevantexperienceyears,_itl_requisitionby_value,itl_requisitionstatus,itl_prescreeningrequired&$orderby=itl_requisitionstatus asc,createdon desc",
      {
        headers: headers,
      }
    );
  },

  addRequisition: (obj) => {
    return axiosInstance.post(
      "/itl_requisitions?$select=itl_requisitionid",
      obj,
      {
        headers: {
          ...headers,
          Prefer: "odata.include-annotations=*,return=representation",
        },
      }
    );
  },

  updateRequisition: (id, obj) => {
    return axiosInstance.patch(`/itl_requisitions(${id})`, obj);
  },

  fetchSingleRequisition: (id) => {
    return axiosInstance.get(
      `/itl_requisitions(${id})?$select=itl_budgetfrom,itl_budgetto,createdon,itl_name,itl_note,itl_department,itl_newjobdescription,_itl_assignto_value,itl_numberofopenings,itl_relevantexperiencemonths,itl_relevantexperienceyears,_itl_requisitionby_value,itl_requisitionstatus,cr225_skillset,itl_prescreeningrequired`,
      {
        headers: headers,
      }
    );
  },

  fetchRequisitionInfoByID: (id) => {
    return axiosInstance.get(`/itl_requisitions(${id})?$select=itl_name`, {
      headers: headers,
    });
  },

  linkCandidate: (id) => {
    return axiosInstance.post(
      `/itl_requisitions(${id})?$select=itl_budgetfrom,itl_budgetto,createdon,itl_name,itl_note,itl_department,itl_newjobdescription,_itl_assignto_value,itl_numberofopenings,itl_relevantexperiencemonths,itl_relevantexperienceyears,_itl_requisitionby_value,itl_requisitionstatus,cr225_skillset`,
      {
        headers: headers,
      }
    );
  },

  fetchLinkedCandidatesByReqID: (id) => {
    return axiosInstance.get(
      `/itl_linkedcandidateses?$select=_itl_candidateid_value,_itl_requisitionid_value&$expand=itl_CandidateID($select=itl_candidatecontact,itl_noticeperiod,itl_candidatecurrentctc,itl_matchingscore,itl_candidateexpectedctc,itl_candidateexpectedctcto,itl_candidatefeedback,lastname,itl_candidatename,itl_candidatenoticeperiod,itl_candidaterelevantexperiencemonths,itl_candidaterelevantexperienceyears,itl_candidaterole,itl_candidatesource,itl_candidatestatus,itl_candidatetotalexperiencemonths,itl_candidatetotalexperienceyears,createdon,itl_dateofbirth,itl_emailid,itl_gender,jobtitle,itl_location,_itl_locationid_value;$expand=itl_LocationID($select=itl_locationname))&$filter=_itl_requisitionid_value eq ${id}&$orderby=itl_activitystamp desc`,
      {
        headers: headers,
      }
    );
  },

  fetchAllLinkedCandidatesByReqID: (id) => {
    return axiosInstance.get(
      `/contacts?$select=itl_candidatecontact,itl_matchingscore,itl_candidatecurrentctc,itl_candidateexpectedctc,itl_candidateexpectedctcto,itl_candidatefeedback,itl_candidatename,itl_candidaterelevantexperiencemonths,itl_candidaterelevantexperienceyears,itl_candidaterole,itl_candidatesource,itl_candidatestatus,itl_candidatetotalexperiencemonths,itl_candidatetotalexperienceyears,createdon,itl_dateofbirth,itl_emailid,fullname,itl_gender,lastname,itl_location,_itl_locationid_value,itl_noticeperiod,itl_reasonforchangeleaving,itl_remark,itl_resume&$filter=_itl_requisitionid_value eq null&$orderby=itl_activitystamp desc&$expand=itl_LocationID($select=itl_locationname),itl_RoleNew($select=itl_name)`,
      {
        headers: headers,
      }
    );
  },

  fetchReqInLinkedCandidateByCandidateID: (id) => {
    return axiosInstance.get(
      `/itl_linkedcandidateses?$select=_itl_requisitionid_value&$expand=itl_RequisitionID($select=itl_requisitionid,_itl_assignto_value,itl_department,itl_name)&$filter=_itl_candidateid_value eq ${id}`,
      {
        headers: headers,
      }
    );
  },

  addLinkedCandidate: (obj) => {
    return axiosInstance.post("/itl_linkedcandidateses", obj, {
      headers: headers,
    });
  },

  deleteLinkedCandidate: (id) => {
    return axiosInstance.delete(`/itl_linkedcandidateses(${id})`, {
      headers: headers,
    });
  },

  updateLinkedCandidate: (id, obj) => {
    return axiosInstance.patch(`/itl_linkedcandidateses(${id})`, obj);
  },

  //update linked candidate score on updating the requistion
  generateMatchingCandidatesOnRequisitionChange: async (requisitionId) => {
    return resumeServiceInstance.post(
      `/match-requisition/${requisitionId}`,
    );
  },

  // generate score when linking the candidate with requisition
  generateLinkedCandidateScore: async (candidateId, requisitionId) => {
    return resumeServiceInstance.post(
      `/match-ai/${candidateId}/${requisitionId}`,
    );
  },

  //delete candidate score details after unlinking 
  deleteUnllinkedCandidateScore: async (candidateId) => {
    const payload = {
      "itl_matchedrequisition": null,
      "itl_matchingscore": null,
      "itl_uipayload": null,
    };

    return axiosInstance.patch(`/contacts(${candidateId})`, payload, {
      headers: {
        ...headers,
        Prefer: "odata.include-annotations=*,return=representation",
      },
    });
  },

  //requsition pre screening
  fetchPreScreeningQuestions: (id) => {
    return axiosInstance.get(
      `/itl_prescreeningquestionses?$select=itl_prescreeningquestionsid,itl_question,itl_requisition,createdon&$filter=_itl_requisition_value eq ${id}&$orderby=createdon desc`,
      {
        headers: headers,
      }
    );
  },

  addPreScreeningQuestions: (obj) => {
    return axiosInstance.post(
      `/itl_prescreeningquestionses`,
      obj,
      {
        headers: headers,
      }
    );
  },

  updatePreScreeningQuestions: (id, obj) => {
    return axiosInstance.patch(`/itl_prescreeningquestionses(${id})`, obj);
  },

  deletePreScreeningQuestions: (id) => {
    return axiosInstance.delete(`/itl_prescreeningquestionses(${id})`, {
      headers: headers,
    });
  },
};

export default requisitionService;
